import type {ReactElement} from 'react';
import {useEffect} from 'react';
import {EmailMakerVersionHistoryPanel} from '@Components/email-maker-version-history-panel/email-maker-version-history-panel';
import {GA4EventName, trackGA4CustomEvent} from '@Libraries/ga-events';
import {getCurrentIdEmailTemplate} from '@EmailMakerReact/lib/email-maker-storage-library';
import {enterVersionHistoryMode, exitVersionHistoryMode, persistRestoredTemplate, previewVersion} from '@EmailMakerReact/lib/email-maker-version-history-library';
import {RightPanelOverlayHeader} from '../../components/right-panel-overlay-header/right-panel-overlay-header';
import type {VersionHistoryViewProps} from './version-history-view.types';
import styles from './version-history-view.module.scss';

/**
 * The React email maker's version-history
 * */
export function VersionHistoryView({editor, onClose, hideHeader}: VersionHistoryViewProps): ReactElement {
  const idEmailTemplate = getCurrentIdEmailTemplate(editor);

  useEffect(() => {
    trackGA4CustomEvent(GA4EventName.EMAILMAKER_VERSION_HISTORY);
    enterVersionHistoryMode(editor);
    return (): void => {
      void exitVersionHistoryMode(editor);
    };
  }, [editor]);

  const renderHeader = (): ReactElement | null => {
    if (hideHeader) {
      return null;
    }
    return <RightPanelOverlayHeader title={window.i18next.t('pmwjs_version_history')} />;
  };

  return (
    <div className={styles.view}>
      {renderHeader()}
      <EmailMakerVersionHistoryPanel
        editor={editor}
        idEmailTemplate={idEmailTemplate}
        previewVersion={previewVersion}
        completeRestore={persistRestoredTemplate}
        onExit={onClose}
        className={styles.panelFill}
      />
    </div>
  );
}
